import Details from "./Details";
import MyOrders from "./MyOrders";
import Orders from "./Orders";
const pages = {
  Main: Orders,
  Details,
  MyOrders,
};
export default pages;